// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2h-zG","additionalInfo":"AgreementModal_additionalInfo__2qzMm"};